import { Button as Cmpt } from "@/components/ui/button";

function Button({variant, ...props }) {
	return <Cmpt 
          variant={variant}
          {...props}
        />;
}

export default Button;